<template>
  <el-select
    style="width: 300px; margin-left: 20px"
    v-model="localValue"
    size="size"
    placeholder="Тип оценивающего"
    multiple="multiple"
    @change="selected"
    filterable
  >
    <el-option
      key="self"
      label="Самооценка"
      value="self"
    />
    <el-option
      key="colleague"
      label="Коллега"
      value="colleague"
    />
    <el-option
      key="subordinate"
      label="Подчиненный"
      value="subordinate"
    />
    <el-option
      key="chief"
      label="Руководитель"
      value="chief"
    />
  </el-select>
</template>

<script>
export default {
  name: "eval-evaluator-status-select",
  props: {
    value: '',
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style>

</style>
